import * as ROUTES from '../backend-routes'
import { executeGet } from '../requests/axios'

export const loadCompanyScopes = function (companyId, onSuccess, onError) {
  executeGet(ROUTES.COMPANIES.PATH_FETCH_COMPANY_SCOPES + companyId + '/scopes', onSuccess, onError)
}
